import React, { createContext, useReducer, useState } from 'react'
import { UploadDataReducer } from './UploadDataReducer'
import {
  apiUrl,
  UPLOAD_DATA_FAIL,
  UPLOAD_DATA_SUCCESS
} from '../constants/constants'
import axios from 'axios'
export const UploadDataContext = createContext()

const UploadDataContextProvider = ({ children }) => {
  const [uploadDataState, dispatch] = useReducer(UploadDataReducer, {
    data: []
  })

  const [showToast, setShowToast] = useState({
    show: false,
    message: '',
    type: null
  })

  const uploadData = async (dataClick, dataRevenue) => {
    try {
      const res = await axios.post(`${apiUrl}/affiliate/uploadData`, [
        dataClick,
        dataRevenue
      ])
      // console.log(res.data.data)
      if (res.data.success) {
        //resourceState.resources = res.data.data
        dispatch({
          type: UPLOAD_DATA_SUCCESS,
          payload: res.data.data
        })
      }
    } catch (error) {
      dispatch({ type: UPLOAD_DATA_FAIL })
    }
  }

  //context data
  const UploadDataContextData = {
    uploadDataState,
    // addUser,
    uploadData,
    // getUser,
    // updateUser,
    showToast,
    setShowToast
    // deleteUser
    // addTodo,
    // deleteTodo,
  }
  return (
    <UploadDataContext.Provider value={UploadDataContextData}>
      {children}
    </UploadDataContext.Provider>
  )
}

export default UploadDataContextProvider
